/*
 * @Descripttion: 物料类型
 * @Author: renbh
 * @Date: 2023-05-05 10:19:21
 * @LastEditors: cb4786
 * @LastEditTime: 2023-08-25 09:20:07
 */

import React, { useMemo } from 'react'
import { Form, Row, Col, Radio, Alert } from 'antd'
import { FormInstance } from 'antd/lib/form'
import {
  materialType,
  MaterialType as MaterialDictType,
} from '../../tools/util'
import { RadioChangeEvent } from 'antd/lib/radio'
import { history, useTypedSelector } from '../../redux/store'
import { SUPROUTE } from '../../route'
import { useAppStore } from '@/stores/appStore'
import { filterPermissionTypeFn } from './util'
import { useLocation } from 'react-router-dom'

// 单个新增物料说明外链
export const SINGLE_MATERIAL_LINK =
  'https://alidocs.dingtalk.com/i/p/VJqzqdoVeOJ1kGYE/docs/Qnp9zOoBVBemynnKuOPaoK7AW1DK0g6l?dontjump=true'
// 批量导入物料说明外链
export const BATCH_MATERIAL_LINK =
  'https://alidocs.dingtalk.com/i/p/VJqzqdoVeOJ1kGYE/docs/14lgGw3P8vLzwggpuA7nRvAjV5daZ90D?dontjump=true'

interface Props {
  form: FormInstance
  setMaterialType?: (val: MaterialDictType) => void
  type: 'single' | 'batch' // 单个/批量 新增
  formItemLayout?: {
    labelCol?: { span: number }
    wrapperCol?: { span: number }
  }
  onChange?: (val: MaterialDictType) => void
  onFieldsChange?: () => void
  diaableMaterialType?: boolean
}

const MaterialType: React.FC<Props> = (props) => {
  const {
    form,
    setMaterialType,
    type,
    formItemLayout = { labelCol: { span: 3 }, wrapperCol: { span: 20 } },
    onChange,
    onFieldsChange,
    diaableMaterialType,
  } = props
  const { cooperateType } = useTypedSelector((state) => state.authtoken)
  const { localCategoryId, localCategoryName } = useTypedSelector(
    (state) => state.goodsReducer,
  )
  const { pathname } = useLocation()
  const userInfo = useAppStore((state) => state.userInfo)

  const itemLayout = { style: { marginBottom: '10px' } }

  const handleJumpBrand = () => {
    history.replace(`${SUPROUTE}/myBrand`)
  }

  // 操作流程内容
  const flowContent =
    type === 'single' ? (
      <>
        <p>第一步：新增物料前，请先维护好您的品牌信息</p>
        <p>
          第二步：填写好物料信息，并提交审核{' '}
          <a
            href={SINGLE_MATERIAL_LINK}
            className="btn-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            查看填写说明
          </a>
        </p>
        <p>
          第三步：咸亨管理员审核通过后，物料生效。如果你的申请被驳回了，请前往【我的申请】重新提交
        </p>
      </>
    ) : (
      <>
        <p>
          第一步：提前在系统内维护好品牌信息{' '}
          <span className="btn-link" onClick={handleJumpBrand}>
            前往维护
          </span>
        </p>
        <p>
          第二步：选择导入的物料类型，并下载模板（电商供应商物料需要勾选关联项目）
        </p>
        <p>
          第三步：上传图片文件，并导入商品模板{' '}
          <a
            href={BATCH_MATERIAL_LINK}
            className="btn-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            查看导入规范
          </a>
        </p>
      </>
    )

  // 切换物料类型
  const onInnerChange = (e: RadioChangeEvent) => {
    const currentType: MaterialDictType = e.target.value
    setMaterialType?.(currentType)
    onChange?.(currentType)
    if (type === 'single') {
      if (currentType === '2') {
        form.setFieldsValue({
          cateName: localCategoryName,
          fourthCateMdmId: localCategoryId,
        })
      } else {
        form.resetFields(['cateName', 'fourthCateMdmId'])
      }
    }
  }

  const masterialTypeOptionsMemo = useMemo(() => {
    return materialType
      .filter((item) => {
        // 物料信息详情，我发起的-编辑
        if (
          pathname.includes('/goodsdetail') ||
          pathname.includes('/launchgoodsInfo')
        ) {
          return true
        }
        return filterPermissionTypeFn(item, { userInfo })
      })
      ?.map((item) => {
        return { key: item.value, value: item.value, label: item.name }
      })
  }, [materialType])
  return (
    <div style={{ overflow: 'hidden', marginBottom: '16px' }}>
      <Row>
        <Col span={24} lg={16} style={{ padding: 16 }}>
          <Alert
            message="操作流程"
            description={flowContent}
            type="info"
            showIcon
          />
        </Col>
      </Row>
      <Form
        {...formItemLayout}
        form={form}
        onFieldsChange={onFieldsChange}
        colon={false}
        labelAlign="right"
        size="small"
      >
        <Form.Item
          label="物料类型"
          name="productType"
          rules={[{ required: true, message: '请选择物料类型' }]}
          {...itemLayout}
          initialValue={masterialTypeOptionsMemo?.[0]?.value}
        >
          <Radio.Group
            disabled={diaableMaterialType}
            size="small"
            onChange={onInnerChange}
            options={masterialTypeOptionsMemo}
          ></Radio.Group>
        </Form.Item>
      </Form>
    </div>
  )
}

export default MaterialType
/*
 * @Descripttion: 物料类型
 * @Author: renbh
 * @Date: 2023-05-05 10:19:21
 * @LastEditors: cb4786
 * @LastEditTime: 2023-08-25 09:20:07
 */

import React, { useMemo } from 'react'
import { Form, Row, Col, Radio, Alert } from 'antd'
import { FormInstance } from 'antd/lib/form'
import {
  materialType,
  MaterialType as MaterialDictType,
} from '../../tools/util'
import { RadioChangeEvent } from 'antd/lib/radio'
import { history, useTypedSelector } from '../../redux/store'
import { SUPROUTE } from '../../route'
import { useAppStore } from '@/stores/appStore'
import { filterPermissionTypeFn } from './util'
import { useLocation } from 'react-router-dom'

// 单个新增物料说明外链
export const SINGLE_MATERIAL_LINK =
  'https://alidocs.dingtalk.com/i/p/VJqzqdoVeOJ1kGYE/docs/Qnp9zOoBVBemynnKuOPaoK7AW1DK0g6l?dontjump=true'
// 批量导入物料说明外链
export const BATCH_MATERIAL_LINK =
  'https://alidocs.dingtalk.com/i/p/VJqzqdoVeOJ1kGYE/docs/14lgGw3P8vLzwggpuA7nRvAjV5daZ90D?dontjump=true'

interface Props {
  form: FormInstance
  setMaterialType?: (val: MaterialDictType) => void
  type: 'single' | 'batch' // 单个/批量 新增
  formItemLayout?: {
    labelCol?: { span: number }
    wrapperCol?: { span: number }
  }
  onChange?: (val: MaterialDictType) => void
  onFieldsChange?: () => void
  diaableMaterialType?: boolean
}

const MaterialType: React.FC<Props> = (props) => {
  const {
    form,
    setMaterialType,
    type,
    formItemLayout = { labelCol: { span: 3 }, wrapperCol: { span: 20 } },
    onChange,
    onFieldsChange,
    diaableMaterialType,
  } = props
  const { cooperateType } = useTypedSelector((state) => state.authtoken)
  const { localCategoryId, localCategoryName } = useTypedSelector(
    (state) => state.goodsReducer,
  )
  const { pathname } = useLocation()
  const userInfo = useAppStore((state) => state.userInfo)

  const itemLayout = { style: { marginBottom: '10px' } }

  const handleJumpBrand = () => {
    history.replace(`${SUPROUTE}/myBrand`)
  }

  // 操作流程内容
  const flowContent =
    type === 'single' ? (
      <>
        <p>第一步：新增物料前，请先维护好您的品牌信息</p>
        <p>
          第二步：填写好物料信息，并提交审核{' '}
          <a
            href={SINGLE_MATERIAL_LINK}
            className="btn-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            查看填写说明
          </a>
        </p>
        <p>
          第三步：咸亨管理员审核通过后，物料生效。如果你的申请被驳回了，请前往【我的申请】重新提交
        </p>
      </>
    ) : (
      <>
        <p>
          第一步：提前在系统内维护好品牌信息{' '}
          <span className="btn-link" onClick={handleJumpBrand}>
            前往维护
          </span>
        </p>
        <p>
          第二步：选择导入的物料类型，并下载模板（电商供应商物料需要勾选关联项目）
        </p>
        <p>
          第三步：上传图片文件，并导入商品模板{' '}
          <a
            href={BATCH_MATERIAL_LINK}
            className="btn-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            查看导入规范
          </a>
        </p>
      </>
    )

  // 切换物料类型
  const onInnerChange = (e: RadioChangeEvent) => {
    const currentType: MaterialDictType = e.target.value
    setMaterialType?.(currentType)
    onChange?.(currentType)
    if (type === 'single') {
      if (currentType === '2') {
        form.setFieldsValue({
          cateName: localCategoryName,
          fourthCateMdmId: localCategoryId,
        })
      } else {
        form.resetFields(['cateName', 'fourthCateMdmId'])
      }
    }
  }

  const masterialTypeOptionsMemo = useMemo(() => {
    return materialType
      .filter((item) => {
        // 物料信息详情，我发起的-编辑
        if (
          pathname.includes('/goodsdetail') ||
          pathname.includes('/launchgoodsInfo')
        ) {
          return true
        }
        return filterPermissionTypeFn(item, { userInfo })
      })
      ?.map((item) => {
        return { key: item.value, value: item.value, label: item.name }
      })
  }, [materialType])
  return (
    <div style={{ overflow: 'hidden', marginBottom: '16px' }}>
      <Row>
        <Col span={24} lg={16} style={{ padding: 16 }}>
          <Alert
            message="操作流程"
            description={flowContent}
            type="info"
            showIcon
          />
        </Col>
      </Row>
      <Form
        {...formItemLayout}
        form={form}
        onFieldsChange={onFieldsChange}
        colon={false}
        labelAlign="right"
        size="small"
      >
        <Form.Item
          label="物料类型"
          name="productType"
          rules={[{ required: true, message: '请选择物料类型' }]}
          {...itemLayout}
          initialValue={masterialTypeOptionsMemo?.[0]?.value}
        >
          <Radio.Group
            disabled={diaableMaterialType}
            size="small"
            onChange={onInnerChange}
            options={masterialTypeOptionsMemo}
          ></Radio.Group>
        </Form.Item>
      </Form>
    </div>
  )
}

export default MaterialType
